import { useApolloClient } from '@apollo/client';
import { CURRENT_USER } from '../GraphQL/Queries';
import useService from './useService';

const useUpdateCurrentUser = () => {
  const client = useApolloClient();
  const { setService } = useService();
  const update = (data) => {
    if (data) {
      client.writeQuery({
        query: CURRENT_USER,
        data: {
          me: {
            ...data,
          },
        },
      });
    } else {
      setService('error');
    }
  };
  return update;
};

export default useUpdateCurrentUser;
